// extracted by mini-css-extract-plugin
export default {"primary":"ExpertCard_primary__LZcs0","avatar":"ExpertCard_avatar__gnC0Z"};